import api from './api';
import { Model, CreateModelData, ModelFilters } from '../types/model';

export const modelService = {
  getAll: async (
    workspaceId: string,
    params?: ModelFilters & { page?: number; limit?: number }
  ) => {
    const response = await api.get(
      `/workspaces/${workspaceId}/models`,
      { params }
    );
    return response.data;
  },

  getById: async (workspaceId: string, id: string) => {
    const response = await api.get(
      `/workspaces/${workspaceId}/models/${id}`
    );
    return response.data;
  },

  create: async (workspaceId: string, data: CreateModelData) => {
    const response = await api.post(
      `/workspaces/${workspaceId}/models`,
      data
    );
    return response.data;
  },

  update: async (workspaceId: string, id: string, data: Partial<CreateModelData>) => {
    const response = await api.put(
      `/workspaces/${workspaceId}/models/${id}`,
      data
    );
    return response.data;
  },

  delete: async (workspaceId: string, id: string) => {
    const response = await api.delete(
      `/workspaces/${workspaceId}/models/${id}`
    );
    return response.data;
  },

  getByProject: async (
    workspaceId: string,
    projectId: string,
    params?: ModelFilters & { page?: number; limit?: number }
  ) => {
    const response = await api.get(
      `/workspaces/${workspaceId}/projects/${projectId}/models`,
      { params }
    );
    return response.data;
  }
};
